export default __webpack_public_path__ + "static/media/aws-s3-icon.bd618ec6.svg";